import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DevicesOtherIcon from "@material-ui/icons/DevicesOther";
import LanguageIcon from "@material-ui/icons/Language";
import SearchIcon from "@material-ui/icons/Search";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";

/**
 * ContactsModule
 * DeviceModule
 * MaintenanceModule
 * SoftwareModule
 * SystemModule
 */
export default function SoftwareModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.ADMIN]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/devices/dashboard");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<DevicesOtherIcon />}
      header={t("adminSideBar.devices")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/devices");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <SearchIcon />
        </ListItemIcon>
        <ListItemText primary={t("search")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/worldmap");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <LanguageIcon />
        </ListItemIcon>
        <ListItemText primary={t("mainSideBar.worldmap")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
